// extracted by mini-css-extract-plugin
module.exports = {"list-item":"_2b-jSGkU2zStZ5t2RbCxwO","list-text":"_3MO67ciG7G9hKajojgvTGn","modifier-text-desc":"_1k-UywsQoJi69qr99fhOVD"};